<template>
  <div class="base-informations">
    <h3 class="base-informations__title">Project information</h3>

    <v-form
      v-model="isFormValid"
      ref="projectBaseInformations"
      class="base-informations__content"
    >
      <v-row>
        <v-col class="base-informations__col">
          <v-text-field
            :value="value.name"
            @input="updateValue({ name: $event })"
            class="form-field"
            :rules="[rules.required]"
            dense
            label="Project name*"
            placeholder="Type name"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col class="base-informations__col">
          <v-select
            :value="value.team_size"
            @change="updateValue({ team_size: $event })"
            :items="teamSizes"
            item-value="value"
            item-text="name"
            item-color="blue"
            :rules="[rules.required]"
            class="form-field"
            dense
            label="Team size*"
            placeholder="Choose size"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col class="base-informations__col">
          <v-menu
            ref="menuDateFrom"
            content-class="datepicker-menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <div class="form-field--date-wrapper" v-on="on">
                <v-text-field
                  :value="value.start_date"
                  @input="updateValue({ start_date: $event })"
                  class="form-field"
                  :rules="[rules.required]"
                  label="From*"
                  placeholder="Chose date"
                  dense
                  readonly
                  v-on="on"
                >
                  <template #append>
                    <v-icon color="blue">
                      mdi-calendar
                    </v-icon>
                  </template>
                </v-text-field>
              </div>
            </template>
            <v-date-picker
              :value="value.start_date"
              no-title
              scrollable
              :max="value.end_date"
              @input="updatePicker({ start_date: $event }, $refs.menuDateFrom)"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="base-informations__col">
          <v-menu
            ref="menuDateTo"
            content-class="datepicker-menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <div class="form-field--date-wrapper" v-on="on">
                <v-text-field
                  :value="value.end_date"
                  @input="updateValue({ end_date: $event })"
                  class="form-field"
                  :rules="[rules.required]"
                  label="To*"
                  placeholder="Chose date"
                  dense
                  readonly
                  v-on="on"
                >
                  <template #append>
                    <v-icon color="blue">
                      mdi-calendar
                    </v-icon>
                  </template>
                </v-text-field>
              </div>
            </template>
            <v-date-picker
              :value="value.end_date"
              no-title
              scrollable
              :min="value.start_date"
              @input="updatePicker({ end_date: $event }, $refs.menuDateTo)"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>

    </v-form>
  </div>
</template>

<script>
import validationRules from '@/helpers/validators';

const rules = validationRules;
const teamSizes = [
  {
    value: 'small',
    name: '1-5',
  },
  {
    value: 'medium',
    name: '6-9',
  },
  {
    value: 'large',
    name: '10+',
  },
];

export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      rules,
      teamSizes,
      isFormValid: true,
    };
  },

  methods: {
    updateValue(val) {
      this.$emit('input', { ...this.value, ...val });
    },

    updatePicker(val, ref) {
      this.updateValue(val);
      ref.save(true);
    },

    validateBaseInformations() {
      this.$refs.projectBaseInformations.validate();
      return this.isFormValid;
    },
  },
};
</script>

<style lang="scss" scoped>
.base-informations {
  margin-bottom: 24px;
  padding: 16px 24px;
  background: #FFFFFF;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 8px;

  &__title {
    color: $main--headers;
    font-size: 18px;
    line-height: 21px;
    font-weight: 500;
    margin-bottom: 16px;
  }

  &__col {
    padding-top: 0;
    padding-bottom: 8px;
  }
}
</style>
